import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGetUserEntitlementsResponse } from "../types/user.types";

type EntitlementsState = {
  data: IGetUserEntitlementsResponse | null;
  loaded: boolean;
};

const initialState: EntitlementsState = { data: null, loaded: false };

const entitlementsSlice = createSlice({
  name: "entitlements",
  initialState,
  reducers: {
    setEntitlements: (
      state,
      action: PayloadAction<IGetUserEntitlementsResponse>
    ) => {
      state.data = action.payload;
      state.loaded = true;
    },
    clearEntitlements: (state) => {
      state.data = null;
      state.loaded = false;
    },
  },
});

export const { setEntitlements, clearEntitlements } = entitlementsSlice.actions;

export default entitlementsSlice.reducer;
